import useMediaQueries from 'app/hooks/useMediaQueries';
import { useCopyProjectMutation } from 'app/services/projects';
import { IProject } from 'app/services/responseTypes';
import { ReuseIcon } from 'assets/icons';
import { errorToast, successToast } from 'Components/Notifications';
import Spinner from 'Components/Spinner';
import Tooltip from 'Components/Tooltips';
import { useNavigate } from 'react-router-dom';

interface IReuseBtn {
  project: IProject;
}

const ReuseBtn = ({ project }: IReuseBtn) => {
  const navigate = useNavigate();
  const { md_down: isMobile } = useMediaQueries();

  const [ReuseProject, { isLoading }] = useCopyProjectMutation();

  return (
    <button
      disabled={isLoading}
      onClick={() => {
        ReuseProject(project.id)
          .unwrap()
          .then((res) => {
            navigate(`/dashboard/questionnaires/${res.project.id}`);
            successToast('Preparing your questionnaire');
          })
          .catch(() => {
            errorToast('An error occured');
          });
      }}
    >
      {isMobile ? (
        <div className="text-sm px-4 w-full font-semibold bg-white text-black flex justify-start items-center h-10 lg:hidden">
          <div className="w-6 mr-2 flex justify-center">
            {isLoading && <Spinner bounce={false} />}
            {!isLoading && <ReuseIcon />}
          </div>
          <span>Reuse</span>
        </div>
      ) : (
        <Tooltip message="Reuse">
          <div className="border border-green rounded-lg hover:shadow-lg md-max:hidden w-10 h-8 flex items-center justify-center">
            {!isLoading && <ReuseIcon className="action-icon" />}
            {isLoading && <Spinner bounce={false} />}
          </div>
        </Tooltip>
      )}
    </button>
  );
};

export default ReuseBtn;
